import axios from 'axios'
import {
                                      // GET_ARCHIVED_REFERRALS_COUNT,
  GET_ARCHIVED_REFERRALS_LIST,
  GET_ARCHIVED_REFERRAL,
  ARCHIVE_REFERRAL
} from './action-constants'

const TABLENAME = 'archivedreferrals'
const TABLENAME_BY_LOGIN_ID =
  'archivedreferrals/bylogin' /*** ROUTE UPDATED TO ADD SECURITY MEASURES */
const TABLENAME_REFERRAL_ARCHIVE_REFERRAL = 'referrals/archive'




                                                                            // const TABLENAME_REFERRAL_COUNT = 'archivedreferrals/count'

                                                                            // export function getArchivedReferralsCount (loginID) {
                                                                            //   const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME_REFERRAL_COUNT + '/' + loginID
                                                                            //   return {
                                                                            //     type: GET_ARCHIVED_REFERRALS_COUNT,
                                                                            //     payload: new Promise((resolve, reject) => {
                                                                            //       axios
                                                                            //         .get(JSONURL)
                                                                            //         .then(function (response) {
                                                                            //           resolve(response)
                                                                            //         })
                                                                            //         .catch(function (error) {
                                                                            //           reject(error)
                                                                            //         })
                                                                            //     })
                                                                            //   }
                                                                            // }





export function getArchivedReferralsList (loginID) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME_BY_LOGIN_ID + '/' + loginID
  return {
    type: GET_ARCHIVED_REFERRALS_LIST,
    payload: new Promise((resolve, reject) => {
      axios
        .get(JSONURL)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}

export function getArchivedReferral (id) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME + '/' + id
  return {
    type: GET_ARCHIVED_REFERRAL,
    payload: new Promise((resolve, reject) => {
      axios
        .get(JSONURL)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}

export function archiveReferral (id, params) {
  const JSONURL =
    process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME_REFERRAL_ARCHIVE_REFERRAL + '/' + id
  return {
    type: ARCHIVE_REFERRAL,
    payload: new Promise((resolve, reject) => {
      axios
        .post(JSONURL, params)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}
